'use strict';

module.exports = require('./makeMakeHot');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/~/react-hot-api/modules/index.js
 ** module id = 217
 ** module chunks = 0
 **/